export default __webpack_public_path__ + "static/media/slider2.2fafe3e6.jpg";